var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"singin"},[(_vm.getStep === 1)?_c('StepOne'):_vm._e(),(_vm.getStep === 2)?_c('StepTwo'):_vm._e(),(_vm.getStep === 3)?_c('StepThree'):_vm._e(),(_vm.getStep === 3.5)?_c('StepThreeBis'):_vm._e(),(_vm.getStep === 4)?_c('StepFour'):_vm._e(),(_vm.getStep === 5)?_c('FinalStep2'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }